// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2Sdsq","savePackageButton":"ClientWallet_savePackageButton__37J3h"};